/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ChevronDown = [["path", { d: "m6 9 6 6 6-6" }]];

export { ChevronDown as default };
//# sourceMappingURL=chevron-down.js.map
